<div class="flex flex-col h-full w-full max-w-full bg-white">
  <header
    class="edit-header sticky top-0 z-10
           px-4 py-3 bg-white border-b"
  >
    <h1 class="text-base font-semibold text-center">
      記録を選択
    </h1>
  </header>

  <div class="flex-1 overflow-y-auto">
    <div
      *ngIf="!isLoading"
      class="px-4 py-3 sm:px-6"
    >
      <form
        [formGroup]="form"
        class="space-y-8 sm:space-y-10"
        (ngSubmit)="onSubmit()"
      >
        <section>
          <h2 class="my-2 text-sm font-medium sm:text-base">
            種類を選択
          </h2>

          <ul *ngIf="titleSetList" class="grid gap-y-2 sm:gap-y-3">
            <li *ngFor="let titleSet of titleSetList; index as i">
              <app-record-select-item
                [titleSet]="titleSet"
                [form]="getForm(i)">
              </app-record-select-item>
            </li>
          </ul>
        </section>

        <app-edit-footer
          [navigationFinally]="historyBackWard"
          excuteText="選択"
          [disabled]="form.invalid">
        </app-edit-footer>
      </form>
    </div>

  </div>
</div>
